import { defineMessages } from 'react-intl-next';

export default defineMessages({
	placeholderButtonLabel: {
		id: 'company-hub.company-hub-common.spotlight.button-label.placeholder',
		defaultMessage: 'View',
		description:
			'Placeholder label that appears in the extension button if there is no text input by the user',
	},
});
